import { FILTERS_NAME } from '@va/constants';
import { useTranslate } from '@va/localization';
import { MultiSelectFilter, SingleSelectFilter, TextFilter } from '@va/shared/feature-filters';
import { FilterOperators } from '@va/types/filters';
import { useMemo } from 'react';
import { useCompanyCategoryOptions, useCompanyOrgType } from '../filter-options';
import { FilterHook } from '../types';

export const useCompanyOrgNameFilter: FilterHook<typeof TextFilter> = (params) => {
  const translate = useTranslate();

  return useMemo(
    () =>
      new TextFilter({
        id: 'companyOrgName',
        name: 'companyOrgName',
        label: translate('filter.companyOrgName'),
        operator: FilterOperators.contains,
        operatorOptions: [FilterOperators.contains, FilterOperators.doesNotContain],
        ...params,
        inputProps: { placeholder: translate('filters.placeholder.companyOrgName'), ...params?.inputProps },
      }),
    [params, translate],
  );
};

export const useCompanyOrgTypeFilter: FilterHook<typeof MultiSelectFilter> = (params) => {
  const translate = useTranslate();
  const companyOrgTypeOptions = useCompanyOrgType();
  return useMemo(
    () =>
      new MultiSelectFilter({
        id: FILTERS_NAME.COMPANY_ORG_TYPE,
        name: FILTERS_NAME.COMPANY_ORG_TYPE,
        label: translate('filter.companyOrgType'),
        ...params,
        inputProps: { useOptions: () => ({ data: companyOrgTypeOptions }), ...params?.inputProps },
      }),
    [companyOrgTypeOptions, params, translate],
  );
};

export const useCompanyCategoryFilter: FilterHook<typeof SingleSelectFilter> = (params) => {
  const translate = useTranslate();

  return useMemo(
    () =>
      new SingleSelectFilter({
        id: FILTERS_NAME.COMPANY_CATEGORY,
        name: FILTERS_NAME.COMPANY_ORG_TYPE,
        label: translate('filter.companyCategory'),
        operator: FilterOperators.is,
        valueMapper: (value) => {
          if (value === 'from') {
            return { [FilterOperators.isNot]: ['isp', ''] };
          }

          return { [FilterOperators.is]: ['isp'], [FilterOperators.isNot]: [''] };
        },
        ...params,
        inputProps: { useOptions: () => ({ data: useCompanyCategoryOptions() }), ...params?.inputProps },
      }),
    [params, translate],
  );
};
